import { render, staticRenderFns } from "./JourneyRenderer.vue?vue&type=template&id=36aa3ba4&scoped=true&"
import script from "./JourneyRenderer.vue?vue&type=script&lang=js&"
export * from "./JourneyRenderer.vue?vue&type=script&lang=js&"
import style0 from "./JourneyRenderer.vue?vue&type=style&index=0&id=36aa3ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aa3ba4",
  null
  
)

export default component.exports